import { createSlice } from '@reduxjs/toolkit';
import { fetchWriterText } from './features';

export const writerAnalyzer = createSlice({
  name: 'writerAnalyzer',
  initialState: {
    formData: null,
    isLoading: false,
    isError: false,
    orderId: null,
    orderType: null,
    orderContentType: null,
    orderSiloName: '',
    orderWebsite: '',
    textType: 'NON_TRANSLATED',
  },
  reducers: {
    clearTextState: (state) => {
      state.formData = null;
      state.isLoading = false;
      state.isError = false;
    },
    updateForm: (state, { payload }) => {
      state.formData = payload;
      state.isLoading = false;
      state.isError = false;
    },
    updateTextForm: (state, { payload }) => {
      let object = { ...state.formData };
      object[payload.key] = payload.value;
      state.formData = { ...object };
    },
    setOrderId: (state, { payload }) => {
      state.orderId = payload;
    },
    setOrderType: (state, { payload }) => {
      state.orderType = payload;
    },
    setTextType: (state, { payload }) => {
      state.textType = payload;
    },
    setOrderSiloName: (state, { payload }) => {
      state.orderSiloName = payload;
    },
    setOrderWebsite: (state, { payload }) => {
      state.orderWebsite = payload;
    },
    setOrderContentType: (state, { payload }) => {
      state.orderContentType = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWriterText.fulfilled, (state, { payload }) => {
        state.formData = payload;
        state.isLoading = false;
      })
      .addCase(fetchWriterText.pending, (state, { payload }) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchWriterText.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export default writerAnalyzer.reducer;

export const {
  clearTextState,
  updateForm,
  updateTextForm,
  setOrderId,
  setOrderType,
  setTextType,
  setOrderSiloName,
  setOrderWebsite,
  setOrderContentType,
} = writerAnalyzer.actions;
export const writerAnalyzerSelector = (state) => state.writerAnalyzer;
